import { REACT_APP_API_ABM_FW } from '../../../common/config';
import axios from "axios";

export async function getPayBranchOffices(pay_company_id) {
  const response = await axios.get(`${REACT_APP_API_ABM_FW}/pagos/branchOffices/${pay_company_id}`)

  return response.data
}